import { ReactElement } from 'react'
import StudentPackage from './StudentPackage'
import { PackageWrapper, Container } from './subcomponents'

const Package = (): ReactElement => {
  return (
    <PackageWrapper>
      <Container>
        <StudentPackage />
      </Container>
    </PackageWrapper>
  )
}

export default Package
